module.exports = __webpack_public_path__ + "static/media/distance.bf89347a.svg";